import { render, staticRenderFns } from "./history-description.vue?vue&type=template&id=7d3a95cc&"
import script from "./history-description.vue?vue&type=script&lang=js&"
export * from "./history-description.vue?vue&type=script&lang=js&"
import style0 from "./history-description.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d3a95cc')) {
      api.createRecord('7d3a95cc', component.options)
    } else {
      api.reload('7d3a95cc', component.options)
    }
    module.hot.accept("./history-description.vue?vue&type=template&id=7d3a95cc&", function () {
      api.rerender('7d3a95cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/club-table/history-description.vue"
export default component.exports